var _rect, _rect2, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeBlockedMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 20,
    viewBox: "0 0 64 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 20,
    width: 64,
    height: 20,
    rx: 10,
    transform: "rotate(-180 64 20)",
    fill: "#474B5A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_781",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 20,
    width: 64,
    height: 20,
    rx: 10,
    transform: "rotate(-180 64 20)",
    fill: "#1CADE4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_781)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.8479,
    y: 36.3256,
    width: 55.2,
    height: 48,
    transform: "rotate(-165 24.8479 36.3256)",
    fill: "#1CADE4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.8003 6.20648C52.5341 5.94027 52.1041 5.94027 51.8379 6.20648L48.5 9.53754L45.1621 6.19966C44.8959 5.93345 44.4659 5.93345 44.1997 6.19966C43.9334 6.46587 43.9334 6.8959 44.1997 7.16212L47.5375 10.5L44.1997 13.8379C43.9334 14.1041 43.9334 14.5341 44.1997 14.8003C44.4659 15.0666 44.8959 15.0666 45.1621 14.8003L48.5 11.4625L51.8379 14.8003C52.1041 15.0666 52.5341 15.0666 52.8003 14.8003C53.0666 14.5341 53.0666 14.1041 52.8003 13.8379L49.4625 10.5L52.8003 7.16212C53.0597 6.90273 53.0597 6.46587 52.8003 6.20648Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeBlockedMale);
export default __webpack_public_path__ + "static/media/free-blocked-male.d2498572391b1f8876d7b3d57413a48b.svg";
export { ForwardRef as ReactComponent };